module.exports = __webpack_public_path__ + "img/ubyt_w.082335ae.svg";